import React from "react";
import { withRouter } from "react-router-dom";
import withSSR from "../components/withSSR";
import DataTable from "../components/DataTable";

import { getTransactions } from "../libs/functions";
import Util from "../libs/util";

import Container from "../components/Container";

class Transactions extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			transactions: [],
			merchant: null,
		};
	}

	componentDidMount = () => {
		const {
			params: { merchant },
		} = this.props.match;

		this.retrieveTransactions(merchant);
	};

	retrieveTransactions = (merchant) => {
		this.setState({ transactions: [] });
		this.props
			.fetchData(this.container.loader, getTransactions, { merchant })
			.then((data) => {
				const { merchant, transactions } = data;
				this.setState({ merchant, transactions });
			});
	};

	render() {
		const { identifier, MDRTypes } = this.props;
		const { merchant, transactions } = this.state;
		return (
			<Container ref={(c) => (this.container = c)} activeMenu={"Merchants"}>
				<div className="Transaction">
					<div className="uk-flex uk-flex-row uk-flex-middle uk-margin-bottom">
						<button
							className="uk-margin-right uk-icon-button uk-button-primary"
							uk-icon="icon: fa-solid-arrow-left; ratio: 0.7"
							uk-tooltip="Back to Merchants"
							type="button"
							onClick={() => this.props.history.push("/merchants")}
						/>
						<h1 className="content-header uk-margin-remove">
							{merchant && `${merchant.name}'s `}
							{identifier}
						</h1>
					</div>
					{MDRTypes ? (
						<div className="uk-card uk-card-small uk-overflow-auto uk-card-body uk-card-default">
							{transactions.length > 0 ? (
								<DataTable
									ref={this.datatableRef}
									className="uk-table uk-table-hover uk-table-striped uk-table-middle uk-table-responsive sales-channel-table"
									options={{
										data: transactions,
										columns: [
											{ data: "transactionId", orderable: false },
											{ data: "salesChannel.name" },
											{
												data: "amount",
												className: "uk-text-center",
												render: (data) => {
													return `$${data}`;
												},
											},
											{
												data: "paymentType",
												className: "uk-text-center",
												render: (data, type) => {
													if (type === "display") {
														if (data) {
															return MDRTypes[data]
																? `<img className="uk-img" src="data:image/*;base64,${MDRTypes[data].image}" width="35"/>`
																: "Payment Link";
														} else return "-";
													} else return data || "-";
												},
											},
											{ data: "status" },
											{
												data: "createdAt",
												className: "uk-text-center",
												render: (data, type) => {
													return type === "sort"
														? data
														: Util.toDateTimeString(data);
												},
											},
										],
										order: [[5, "desc"]],
									}}
								>
									<thead>
										<tr>
											<th className="uk-width-1-6">Transaction ID</th>
											<th className="uk-width-1-6">Sales Channel</th>
											<th>Amount</th>
											<th>Payment Type</th>
											<th>Status</th>
											<th className="uk-width-1-6">Created At</th>
										</tr>
									</thead>
								</DataTable>
							) : (
								<span>No Transaction Records</span>
							)}
						</div>
					) : null}
				</div>
			</Container>
		);
	}
}

export default withSSR(withRouter(Transactions));
